import {
  TabPanelPassThroughOptions,
  TabViewPassThroughOptions,
} from 'primereact/tabview';
import { classNames } from 'primereact/utils';

const PTTabPanel: TabPanelPassThroughOptions = {
  root: {
    className: 'ax-tabpanel',
  },
  header: {
    className: classNames('ax-tabpanel__header'),
  },
  headerAction: {
    className: '',
  },
  headerTitle: {
    className: '',
  },
  content: {
    className: '',
  },
};
export const PTTabView: TabViewPassThroughOptions = {
  root: {
    className: 'ax-tabview',
  },
  navContainer: {
    className: 'ax-tabview__nav-container',
  },
  navContent: {
    className: '',
  },
  nav: {
    className: '',
  },
  inkbar: {
    className: 'ax-tabview__inkbar',
  },
  panelContainer: {
    className: '',
  },
  tab: { ...PTTabPanel },
};
